import { Directive, TemplateRef } from '@angular/core';

/**
 * Directive for custom combobox dropdown item template
 * Use this to customize how complex objects are displayed in the dropdown
 * 
 * Note: Use a template reference variable and pass it via [comboboxOptionTemplate].
 * Since <input> is a void element, the template must be defined as a sibling.
 * 
 * @example
 * <input combobox [comboboxData]="users" [comboboxOptionTemplate]="itemTemplate" />
 * <ng-template #itemTemplate let-item let-index="index">
 *   <i class="icon-{{item.icon}}"></i>
 *   {{ item.name }}
 * </ng-template>
 */
@Directive({
  selector: '[comboboxOption]'
})
export class ComboboxOptionDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
